var portfolioTransactionsList = {
	caption: "Transazioni di portafoglio",
	date: "Data",
	time: "Ora",
	name: "Nome",
	isin: "ISIN",
	transactionType: "Tipo ",
	numberOfShares: "Quantità/Nominale",
	executionPrice: "Prezzo di esecuzione",
	executionValue: "Valore di esecuzione",
	assetClass: "Asset class",
	actions: "Azioni",
	buy: "Acquisto",
	sell: "Vendita",
	cash: "Contanti",
	payout: "Cash",
	short: "Corta",
	cover: "Copertura",
	noTransactions: "Nessun risultato trovato",
	bond: "Obbligazione",
	commodity: "Materie Prime",
	currency: "Valuta",
	debt: "Debito",
	etf: "ETF",
	fund: "Fondo",
	generic: "Generico",
	index: "Indice",
	stock: "Azione",
	interestRate: "Tasso di Interesse",
	structuredProduct: "Prodotto Strutturato",
	investmentProduct: "Prodotto di Investimento",
	leveragedProduct: "Prodotto a Leva",
	option: "Opzione",
	future: "Future"
};
var it = {
	portfolioTransactionsList: portfolioTransactionsList
};

export { it as default, portfolioTransactionsList };
